import axios from 'axios';
import * as Sentry from '@sentry/react';
import { BASE_URL } from '../consts/baseUrl.const';

const createAxiosInstance = () => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  const instance = axios.create({
    baseURL: import.meta.env?.DEV ? '' : BASE_URL,
    headers,
    withCredentials: true,
    responseType: 'json',
  });

  instance.interceptors.response.use(
    r => r,
    error => {
      // В продакшене отправляем исключения в Sentry (если настроен DSN)
      if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
        Sentry.captureException(error, {
          tags: { transport: 'axios' },
          extra: {
            url: error?.config?.url,
            method: error?.config?.method,
            status: error?.response?.status,
          },
        });
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

const http = createAxiosInstance();

export { http };
